import { useEffect } from 'react';

export function useSeo(title: string, description?: string) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const el = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (el) el.setAttribute('content', description);
    }
  }, [title, description]);
}
